'use client';

import {ArticlesWithSelectionsView} from '@shared/Articles/ArticlesWithSelectionsView/ArticlesWithSelectionsView';

import {ArticlesMainInfo} from '@strapi/types';
import {articleSelectionType} from '@strapi/types/ArticleMainInfo';
import {CategoriesType} from '@strapi/types/Categories';

import {useSwiperSlideAnalytics} from '@web-landing/analytics/hooks/useSwiperSlideAnalytics';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EVENTS} from '@web-landing/analytics/events';

type Props = {
  category: CategoriesType[];
  articlesInfo: ArticlesMainInfo;
};
export const ProstoreSelectionsView = ({category, articlesInfo}: Props) => {
  const {logCompilationSwipe} = useSwiperSlideAnalytics();
  const handleSwiperSlide = (
    selection: articleSelectionType,
    selectionNumber: number,
  ) => logCompilationSwipe(selection, selectionNumber);

  const handleArticleCardClick = (
    compilationName: string,
    articleName: string,
  ) => {
    logTmrEvent(EVENTS.articleClick, {
      category_name: 'Интересное',
      compilation_name: compilationName,
      article_name: articleName,
    });
  };

  const handleCategoryItemClick = (category_name: string) => {
    logTmrEvent(EVENTS.prostoreCategoryClick, {category_name: category_name});
  };

  return (
    <ArticlesWithSelectionsView
      categories={category}
      currentCategoryUrl=""
      articlesInfo={articlesInfo}
      basePath={'prostore'}
      handleArticleSelectionSwipe={handleSwiperSlide}
      handleArticleCardClick={handleArticleCardClick}
      handleCategoryItemClick={handleCategoryItemClick}
    />
  );
};
